import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
  children?: React.ReactNode;
}

export const LpFilterBar = styled.div<IProps>`
  position: relative;
  background-color: #fff;
`;

export const PinArea = styled.div<IProps>`
  width: 100%;
  background-color: #fff;

  .dynm-btn {
    svg {
      flex-shrink: 0;
    }
  }
`;

export const Area = styled.div<IProps>`
  ${mixin.flex({ justify: 'space-between' })};
  width: 100%;
  background-color: #fff;

  &.area-quick {
    padding-top: 12px;
  }

  &.area-filter {
    padding-top: 8px;

    /* 선택칩 행이 없어 마지막 행일 때 */
    &:last-child {
      padding-bottom: 8px;
    }
  }

  &.area-selected {
    margin-top: 8px;
    padding-top: 12px;
    padding-bottom: 11px;
    border-bottom: 1px solid #eee;
    background-color: #f6f6f6;

    .list {
      gap: 12px;
      padding-right: 30px;
    }

    .dynm-btn.type-close {
      height: auto;
      background-color: transparent;

      .btn {
        height: 17px;
        padding: 0;

        .text {
          line-height: 130%;
          font-size: 13px;
          color: #999;
          font-weight: 500;
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    &.area-quick {
      padding-top: ${mixin.pxToVw('12')};
    }

    &.area-filter {
      padding-top: ${mixin.pxToVw('8')};

      &:last-child {
        padding-bottom: ${mixin.pxToVw('8')};
      }
    }

    &.area-selected {
      margin-top: ${mixin.pxToVw('8')};
      padding-top: ${mixin.pxToVw('12')};
      padding-bottom: ${mixin.pxToVw('11')};

      .list {
        gap: ${mixin.pxToVw('12')};
        padding-right: ${mixin.pxToVw('30')};
      }

      .dynm-btn.type-close {
        .btn {
          height: ${mixin.pxToVw('17')};
          padding: 0;

          .text {
            font-size: ${mixin.pxToVw('13')};
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    border-bottom: none;

    &.area-filter {
      padding-top: 12px;

      &:last-child {
        padding-bottom: 12px;
      }
    }

    &.area-selected {
      margin-top: 12px;
      padding: 16px 22px 15px 22px;
      border-bottom: none;

      .list {
        gap: 20px;
        padding-right: 20px;
      }

      .dynm-btn.type-close {
        .btn {
          .text {
            font-size: 17px;
          }
        }
      }
    }
  }
`;

export const List = styled.div<IProps>`
  ${mixin.flex({ justify: 'flex-start' })};
  gap: 5px;
  min-width: 0;
  flex: 1;
  padding: 0 16px 1px 16px;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  overflow-y: hidden;
  overflow-x: auto;
  overscroll-behavior: contain auto;

  &::-webkit-scrollbar {
    display: none;
  }

  > * {
    flex: none;
  }

  @media ${({ theme }) => theme.media.smMax} {
    gap: ${mixin.pxToVw('5')};
    padding: ${mixin.pxToVw('0 16 1 16')};
  }

  @media ${({ theme }) => theme.media.pc} {
    gap: 6px;
    padding: 0 0 1px 0;
    overflow-x: visible;
    flex-wrap: wrap;
    white-space: normal;
  }
`;

export const Reset = styled.span<IProps>`
  flex: none;
  position: relative;
  padding-right: 16px;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -16px;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      270deg,
      #f6f6f6 79.55%,
      rgba(246, 246, 246, 0) 105%
    );
  }

  .btn .text {
    position: relative;
    line-height: 130%;
    font-size: 13px;
    color: #777;
    text-decoration-line: underline;
    z-index: 1;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding-right: ${mixin.pxToVw('16')};

    &:before {
      left: ${mixin.pxToVw('-16')};
    }

    .btn .text {
      font-size: ${mixin.pxToVw('13')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding-right: 0;

    &:before {
      left: -22px;
    }

    .btn .text {
      font-size: 16px;
    }
  }
`;
